@for (companyCategory of categoryTree; track companyCategory) {
  <div class="category-tree">
    <div class="category-title">
      {{ companyCategory.company_category_name }}
    </div>
    <ul>
      @for (category of companyCategory.categories; track category) {
        <li>
          <sui-checkbox
            [checked]="isSelected(category.id)"
            (checkedChange)="toggleCheckbox(category)"
          >
            {{ category.name }}
          </sui-checkbox>
          @if (category.children?.length > 0) {
            <ul>
              <ng-container
                *ngTemplateOutlet="
                  childTemplate;
                  context: { $implicit: category.children }
                "
              ></ng-container>
            </ul>
          }
        </li>
      }
    </ul>
    <ng-template #childTemplate let-children>
      @for (child of children; track child) {
        <li>
          <sui-checkbox
            [checked]="isSelected(child.id)"
            (checkedChange)="toggleCheckbox(child)"
          >
            {{ child.name }}
          </sui-checkbox>
          @if (child.children && child.children.length > 0) {
            <ul>
              <ng-container
                *ngTemplateOutlet="
                  childTemplate;
                  context: { $implicit: child.children }
                "
              ></ng-container>
            </ul>
          }
        </li>
      }
    </ng-template>
  </div>
}
